export default "__VITE_ASSET__BMAerccN__"